export default __webpack_public_path__ + "static/media/section2-guide-bar.0595684d.png";